import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {CUSTOMER_TYPES} from '../../../services/constant';
import {Router} from '@angular/router';
import {CustomerDetailComponent} from '../customer-detail/customer-detail.component';
import {HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss']
})
export class CustomerListComponent implements OnInit {

  totalItems: number;
  currentPage = 1;
  itemsPerPage = 40;

  searchName;
  searchTaxID;
  searchBranchCode;
  searchBranchName;
  searchingName: boolean = false;
  searchingTaxID: boolean = false;
  searchingBranchCode: boolean = false;
  searchingBranchName: boolean = false;
  loading = false;
  sentdata = null;
  list: any[] = [];
  buyerNameList: any[];
  buyerBranchCodeList: any[];
  buyerBranchNameList: any[];
  buyerTaxIDList: any[];
  customerTypes = CUSTOMER_TYPES;

  selectedCustomerType = this.customerTypes[0];

  @ViewChild('detailModal') detailModal: CustomerDetailComponent;

  constructor(private apiService: ApiService,
              private router: Router) {
  }

  ngOnInit() {
    this.initData();
    this.loadData();
  }

  get isForeignCorporation() {
    return this.selectedCustomerType.type === 'foreign_corporation';
  }

  selectCustomerType(type) {
    this.selectedCustomerType = type;
    this.loadData();
  }

  initData() {
    this.apiService.getNewBuyer().subscribe(
      (res: any) => {
        this.buyerNameList = res.map(obj => obj.name).filter(item => item).filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
        this.buyerTaxIDList = res.map(obj => obj.tax_id).filter(item => item).filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      });
    this.apiService.getBuyerBranch().subscribe(
      (res) => {
        this.buyerBranchCodeList = res.results.map(obj => obj.branch_code).filter(item => item).filter((item, index, array) => {
          return array.indexOf(item) === index;
        });
      }
    );
  }

  loadData(page?) {
    const sniffTargetArr: string[] = [];
    let params = new HttpParams();

    if (this.searchName) {
      params = params.append('name', this.searchName);
      sniffTargetArr.push('NORMAL.CUS-NAME');
    }

    if (this.searchTaxID) {
      params = params.append('tax_id', this.searchTaxID);
      sniffTargetArr.push('TABLE.TAX-ID');
    }

    if (this.searchBranchCode) {
      params = params.append('branch_code', this.searchBranchCode);
      sniffTargetArr.push('NORMAL.BRANCH-NAME-CODE');
    }

    if (this.searchBranchName) {
      params = params.append('branch_name', this.searchBranchName);
    }

    if (this.sentdata) {
      params = params.append('page', this.currentPage.toString());
      params = params.append('page_size', this.itemsPerPage.toString());
    }

    this.loading = true;
    this.apiService.getBuyerBranch(params).subscribe(
      (res: any) => {
        this.list = res.results;
        this.loading = false;
        if (res) {
          this.totalItems = res.count;
        }
      },
      error => {
        this.loading = false;
      }
    );

    if (page == null) {
      const sniffTarget = sniffTargetArr.join(', ');
      this.sniff('SEARCH', sniffTarget);
    }
  }

  pageChanged() {
    this.sentdata = 1;
    this.loadData(this.currentPage);
  }

  optionChanged() {
    this.search();
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  clearSearch() {
    this.searchName = null;
    this.searchTaxID = null;
    this.searchBranchCode = null;
    this.searchBranchName = null;
    this.search();
  }

  openModal(index) {
    this.detailModal.open(this, this.selectedCustomerType, this.list[index]);
  }

  issue(index) {
    const id = this.list[index].id;
    this.router.navigate(['document', 'issue', {buyer_branch: id}]);
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'CUS_INFO',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-list/customer-list.component.ts